import * as React from "react";
import "./index.css";
import { widget } from "./charting_library/charting_library.min";
import Datafeed from "./datafeeds/datafeed";
import { CURRENCY } from "@core/utils/consts";
import { getExchangeSlug } from "@core/utils";
import { getBrowserTradingChartTimezone } from "./timezones";

// function getLanguageFromURL() {
//   const regex = new RegExp("[\\?&]lang=([^&#]*)");
//   const results = regex.exec(window.location.search);
//   return results === null
//     ? null
//     : decodeURIComponent(results[1].replace(/\+/g, " "));
// }

export class TVChartContainer extends React.PureComponent {
  // static contextType = Context;

  static defaultProps = {
    symbol: `${getExchangeSlug()}:${CURRENCY?.TYPE?.BTC?.SYMBOLS?.IRT}`,
    interval: "240",
    containerId: "tv_chart_container",
    // datafeedUrl: "https://demo_feed.tradingview.com",
    libraryPath: "/charting_library/",
    chartsStorageUrl: "https://saveload.tradingview.com",
    chartsStorageApiVersion: "1.1",
    clientId: "tradingview.com",
    userId: "public_user_id",
    theme: "Dark",
    fullscreen: false,
    autosize: true,
    studiesOverrides: {},
  };

  tvWidget = null;

  componentDidMount() {
    const { themeColor } = this.props.theme;

    const widgetOptions = {
      symbol: this.props.symbol,
      datafeed: Datafeed,
      interval: this.props.interval,
      container_id: this.props.containerId,
      library_path: this.props.libraryPath,
      locale: "en",
      charts_storage_url: this.props.chartsStorageUrl,
      charts_storage_api_version: this.props.chartsStorageApiVersion,
      client_id: this.props.clientId,
      user_id: this.props.userId,
      theme: themeColor,
      // Initial display TZ from browser (e.g. Asia/Tehran → UTC+03:30)
      timezone: getBrowserTradingChartTimezone(),
      fullscreen: this.props.fullscreen,
      autosize: this.props.autosize,
      studies_overrides: this.props.studiesOverrides,
      disabled_features: ["use_localstorage_for_settings"],
      enabled_features: [],
      // Bottom toolbar presets: only resolutions >= 1h (aligned with Gereh/Dena)
      time_frames: [
        { text: "1d", resolution: "60", description: "1 Day" },
        { text: "5d", resolution: "60", description: "5 Days" },
        { text: "1m", resolution: "240", description: "1 Month" },
        { text: "3m", resolution: "240", description: "3 Months" },
        { text: "6m", resolution: "720", description: "6 Months" },
        { text: "1y", resolution: "1D", description: "1 Year" },
      ],
      favorites: {
        intervals: ["60", "120", "240", "360", "720", "1D"],
      },
      overrides: {
        // "paneProperties.background": "#131722",
        // "paneProperties.vertGridProperties.color": "#363c4e",
        // "paneProperties.horzGridProperties.color": "#363c4e",
        // "symbolWatermarkProperties.transparency": 90,
        // "scalesProperties.textColor": "#AAA",
        // "mainSeriesProperties.candleStyle.wickUpColor": "#336854",
        // "mainSeriesProperties.candleStyle.wickDownColor": "#7f323f",
      },
    };

    const tvWidget = new widget(widgetOptions);
    this.tvWidget = tvWidget;

    tvWidget.onChartReady(() => {
      tvWidget.headerReady().then(() => {
        const button = tvWidget.createButton();
        button.setAttribute("title", "Click to show a notification popup");
        button.classList.add("apply-common-tooltip");
        button.addEventListener("click", () =>
          tvWidget.showNoticeDialog({
            title: "Notification",
            body: "TradingView Charting Library API works correctly",
            callback: () => {
              console.log("Noticed!");
            },
          })
        );

        button.innerHTML = "Check API";
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.theme !== prevProps.theme) {
      this.tvWidget.changeTheme(this.props.theme);
    }
    if (this.props.symbol !== prevProps.symbol) {
      this.tvWidget.setSymbol(this.props.symbol, this.props.interval);
    }
  }

  componentWillUnmount() {
    if (this.tvWidget !== null) {
      this.tvWidget.remove();
      this.tvWidget = null;
    }
  }

  render() {
    return <div id={this.props.containerId} className={"TVChartContainer"} />;
  }
}
